import { motion, useReducedMotion } from "framer-motion";
import { Thermometer, MessageCircle, ScanFace, Tag, CheckCheck } from "lucide-react";

const FEED = [
  { icon: Thermometer, title: "Câmara fria · Cozinha A", sub: "2,8 °C · dentro da faixa", tag: "Conforme", tone: "emerald", t: "06:41" },
  { icon: ScanFace, title: "Totem de ponto · Entrada", sub: "Beatriz R. · rosto validado", tag: "07:02", tone: "sky", t: "07:02" },
  { icon: Tag, title: "Etiqueta impressa · Lote 078A", sub: "Filé mignon porcionado · VAL 18/07", tag: "PVPS", tone: "amber", t: "07:15" },
  { icon: MessageCircle, title: "WhatsApp · Gerência", sub: "Abertura aprovada com GPS verificado", tag: "Enviado", tone: "emerald", t: "07:20" },
];

const TONE = {
  emerald: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30",
  sky: "bg-sky-500/15 text-sky-300 border-sky-500/30",
  amber: "bg-amber-500/15 text-amber-300 border-amber-500/30",
};

export function LiveFeedCard() {
  const reduce = useReducedMotion();
  return (
    <div className="relative" data-testid="hero-live-card">
      <div className="absolute -inset-3 rounded-[28px] bg-emerald-800/10 rotate-2" aria-hidden />
      <div className="relative rounded-2xl bg-stone-950 text-white border border-stone-800 shadow-2xl overflow-hidden">
        <div className="flex items-center justify-between px-5 py-3.5 border-b border-stone-800">
          <div className="flex items-center gap-2">
            <span className="relative flex h-2.5 w-2.5">
              <span className={`absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75 ${reduce ? "" : "animate-ping"}`} />
              <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-emerald-500" />
            </span>
            <span className="font-body text-xs text-stone-300">Cozinha Matriz · ao vivo</span>
          </div>
          <span className="font-mono text-[10px] text-stone-500 uppercase tracking-widest">Turno manhã</span>
        </div>
        <ul className="divide-y divide-stone-800/80">
          {FEED.map((f, i) => (
            <motion.li
              key={f.title}
              initial={reduce ? false : { opacity: 0, x: 16 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: 0.35 + i * 0.15, duration: 0.5 }}
              className="flex items-center gap-3.5 px-5 py-3.5"
            >
              <div className="h-9 w-9 rounded-lg bg-stone-900 border border-stone-800 flex items-center justify-center text-emerald-400">
                <f.icon className="h-4 w-4" />
              </div>
              <div className="flex-1 min-w-0">
                <div className="font-display text-sm font-semibold truncate">{f.title}</div>
                <div className="font-body text-xs text-stone-400 truncate">{f.sub}</div>
              </div>
              <span className={`text-[10px] font-bold px-2 py-0.5 rounded-full border font-body ${TONE[f.tone]}`}>{f.tag}</span>
            </motion.li>
          ))}
        </ul>
        <div className="px-5 py-3 bg-stone-900/60 border-t border-stone-800 flex items-center justify-between">
          <span className="font-body text-xs text-stone-400">Conformidade do turno</span>
          <span className="font-display text-lg font-extrabold text-emerald-400">100%</span>
        </div>
      </div>

      <motion.div
        initial={reduce ? false : { opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 1.1, duration: 0.5 }}
        className="absolute -bottom-6 -left-4 sm:-left-10 max-w-[280px] rounded-2xl rounded-tl-sm bg-[#dcf8c6] text-stone-900 shadow-xl border border-emerald-200 px-4 py-3"
        data-testid="hero-whatsapp-bubble"
      >
        <div className="font-body text-[11px] font-bold text-emerald-900">Ultra · Cozinha organizada</div>
        <p className="font-body text-xs leading-snug mt-0.5">
          Abertura da <b>Cozinha Matriz</b> concluída 100% conforme às 06:45. Relatório PDF anexo.
        </p>
        <div className="mt-1 flex justify-end items-center gap-1 text-[10px] text-stone-500 font-body">
          07:20 <CheckCheck className="h-3.5 w-3.5 text-sky-500" />
        </div>
      </motion.div>
    </div>
  );
}
